export default __webpack_public_path__ + "static/media/cowicon.7c129903.png";